<script setup lang="ts">
import {MyFileUploader} from "@/types";
import {ref} from "vue";
import {getDurationStr} from "@/utils/common.ts";

defineProps<{
  uploaderList: MyFileUploader[] | undefined
}>()

const visible = ref(false)
const show = () => {
  visible.value = true
}
const hide = () => {
  visible.value = false
}

defineExpose({ show, hide })
</script>

<template>
  <el-dialog v-model="visible" title="上传队列" align-center>
    <el-table :data="uploaderList">
      <el-table-column label="视频名称">
        <template #default="scope">
          {{ scope.row.file.name }}
        </template>
      </el-table-column>
      <el-table-column label="时长">
        <template #default="scope">
          {{ getDurationStr(scope.row.file.duration) }}
        </template>
      </el-table-column>
      <el-table-column label="视频宽高">
        <template #default="scope">
          {{ `${scope.row.file.width} x ${scope.row.file.height}` }}
        </template>
      </el-table-column>
      <el-table-column label="上传进度">
        <template #default="scope">
          {{ `${scope.row.file.progress || 0}%` }}
        </template>
      </el-table-column>
      <el-table-column label="上传状态">
        <template #default="scope">
          {{ scope.row.status === 1 ? '上传成功' : '上传中' }}
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<style scoped>
</style>
